import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from 'api/internalToolsActivity/internalToolsActivity';
import * as toastActions from 'state/toast/actions';
import { DO_FORCE_ACTIVATE_PAYMENT } from 'state/actionTypes';
import { setForceActivationResult } from 'state/activation/actions';
import {
  FORCE_ACTIVATION_SUCCESS,
  FORCE_ACTIVATION_FAILED,
} from 'state/activation/messageConstants';

export function* forceActivationSaga({ payload }) {
  try {
    const response = yield call(api.forceActivation, payload);
    const result = {
      data: response.data.data,
    };
    yield put(setForceActivationResult(result));
    yield put(toastActions.successMessage(FORCE_ACTIVATION_SUCCESS));
  } catch (error) {
    yield put(
      toastActions.errorMessage(FORCE_ACTIVATION_FAILED, error.message)
    );
  }
}

export default function* saga() {
  yield takeLatest(DO_FORCE_ACTIVATE_PAYMENT, forceActivationSaga);
}
